$(document).ready(function () {
    var styleElem = window.parent.document.head.appendChild(document.createElement("style"))
    styleElem.innerHTML = ".is-storefront .se-control-label.required:before {color: red;}";
  
});